export default __webpack_public_path__ + "static/media/hedge_cutting.3bc13c90.jpg";